<template>
  <div :key="user" class="fixed bottom-8 left-0 flex flex-row items-center justify-center w-full px-4 z-50 pointer-events-none">
    <div class="flex flex-col md:flex-row items-center gap-4 pointer-events-auto">
      <!-- User Badge - Floating style -->
      <div v-if="user && user.email" class="bg-emerald-500 text-white px-4 py-2 rounded-2xl shadow-lg border border-emerald-400/50 flex items-center gap-3 backdrop-blur-md">
        <div class="flex flex-col leading-tight">
          <span class="text-[10px] uppercase font-bold opacity-80">Logado como</span>
          <span class="text-sm font-bold">{{ user.email }}</span>
        </div>
        <button @click="() => registerStore.logout()" class="!bg-white/20 !p-1.5 !rounded-lg !shadow-none !text-xs hover:!bg-white/30 transition-colors">Sair</button>
      </div>

      <!-- Main Float Action Card -->
      <div class="bg-white/80 backdrop-blur-xl border border-slate-200/50 rounded-[2rem] p-3 shadow-2xl shadow-slate-900/10 flex items-center gap-6 min-w-[300px] justify-center">
        <div class="flex items-center gap-4 w-full justify-center">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useRegisterStore } from '@/store/registerStore';
import { computed } from 'vue';
const registerStore = useRegisterStore();
const user = computed(() => registerStore.user, { deep: true, immediate: true });
</script>